import { fetchRequestWithTypes } from './index.js';

export const POST_ENROLLMENTS_REQUEST = 'POST_ENROLLMENTS_REQUEST';
export const POST_ENROLLMENTS_SUCCESS = 'POST_ENROLLMENTS_SUCCESS';
export const POST_ENROLLMENTS_ERRORED = 'POST_ENROLLMENTS_ERRORED';

export type EnrollmentsRequestPayload = {
	userId: string;
	enrollment: {
		accountTypes: string[];
	};
};

/**
 * Opens entitled accounts (Bank + brokerage, optionally Smart) via experiences enrollments.
 * Path matches other stash-web experiences calls (`/apis/experiences/v1/...`).
 */
export const postEnrollments = (body: EnrollmentsRequestPayload) =>
	fetchRequestWithTypes({
		types: [POST_ENROLLMENTS_REQUEST, POST_ENROLLMENTS_SUCCESS, POST_ENROLLMENTS_ERRORED],
		request: {
			method: 'POST',
			path: '/apis/experiences/v1/enrollments',
			body,
		},
	});
